var request = require('./request');
var config = require('./config');
var resolve = require('./resolve');

exports.DownloadFileWithGivenName = function ($document, $timeout, data, filename, fileType) {
  var headers = new Object();
  headers['x-filename'] = filename;
  headers['content-type'] = fileType;

  exports.DownloadFileFromData($document, $timeout, data, headers);
}

exports.DownloadFileFromData = function ($document, $timeout, data, headers) {
  var octetStreamMime = 'application/octet-stream';
  var success = false;

  // Get the headers
  //            headers = headers();

  // Get the filename from the x-filename header or default to "download.bin"
  var filename = headers['x-filename'] || 'download.bin';

  // Determine the content type from the header or default to "application/octet-stream"
  var contentType = headers['content-type'] || octetStreamMime;

  try {
    // Try using msSaveBlob if supported
    var blob = new Blob([data], { type: contentType });

    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename);
    } else {

      var downloadContainer = angular.element('<div data-tap-disabled="true"><a></a></div>');
      var downloadLink = angular.element(downloadContainer.children()[0]);
      downloadLink.attr('href', window.URL.createObjectURL(blob));
      downloadLink.attr('download', filename);
      downloadLink.attr('target', '_blank');

      $document.find('body').append(downloadContainer);
      $timeout(function () {
        downloadLink[0].click();
        downloadLink.remove();
      }, null);
    }
  } catch (ex) {
    alert("saveBlob method failed with the following exception: " + ex.message);
  }
}
